export default {
    header: state => state.header,
    footer: state => state.footer,
    isLogin: state => !!state.token,
    showlogin: state => state.showlogin,
    notice: state => state.notice,
    user: state => state.user,
    ding: state => state.ding,
    dingSuccess: state => state.dingSuccess,
    showMoreFree: state => state.showMoreFree,
    showTreaty: state => state.showTreaty,
    showMianze: state => state.showMianze,
}
